import { render, staticRenderFns } from "./OrderIdentify.vue?vue&type=template&id=04adc2a9&scoped=true&"
import script from "./OrderIdentify.vue?vue&type=script&lang=js&"
export * from "./OrderIdentify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04adc2a9",
  null
  
)

export default component.exports